import { render, staticRenderFns } from "./agingStockBarChart.vue?vue&type=template&id=f538ce70&scoped=true"
import script from "./agingStockBarChart.vue?vue&type=script&lang=js"
export * from "./agingStockBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f538ce70",
  null
  
)

export default component.exports